<template>
    <div v-for="(popup, index) in visiblePopups" :key="popup.idx" class="popup-overlay" :style="{ top: popup.top + 'px', left: popup.left + 'px' }">
        <div class="popup">
            <div class="popup-content" data-lenis-prevent v-html="popup.contents"></div>

            <div class="popup-footer">
                <div class="popup-checkbox">
                    <input type="checkbox" :id="'doNotShowToday' + popup.idx" v-model="dontShowAgain[index]" />
                    <label :for="'doNotShowToday' + popup.idx">하루 동안 보지 않기</label>
                </div>
                <button @click="closePopup(index)">닫기</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        popupData: { type: Array, required: true },
    },
    emits: ['close-popup'],
    data() {
        return {
            dontShowAgain: [],
        };
    },
    computed: {
        visiblePopups() {
            const today = new Date();
            return this.popupData?.filter((popup) => {
                const hiddenUntil = localStorage.getItem(`popup_hidden_until_${popup.idx}`);
                if (hiddenUntil && new Date(hiddenUntil) > today) {
                    return false;
                }

                const startDate = new Date(popup.startDate);
                const endDate = new Date(popup.endDate);
                return today >= startDate && today <= endDate;
            });
        },
    },
    watch: {
        popupData(newVal) {
            if(Array.isArray(newVal)) this.dontShowAgain = newVal.map(() => false);
        },
    },
    methods: {
        closePopup(index) {
            const popup = this.visiblePopups[index];

            if (this.dontShowAgain[index]) {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                localStorage.setItem(`popup_hidden_until_${popup.idx}`, tomorrow);
            }

            this.$emit('close-popup', popup.idx);
        },
    },
};
</script>

<style scoped>
.popup-overlay {
    position: fixed;
    z-index: 1002;

    @media screen and (max-width: 768px){
        top: 30px !important;
        left: 50% !important;
        transform: translateX(-50%);
    }
}

.popup {
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    max-width: 400px;
    min-width: 300px;
    text-align: center;
}

.popup-content {
    text-align: left;
    margin-top: 10px;
    max-height: 500px;
    padding: 20px;
    overflow: auto;
}

.popup-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background-color: #333;
    color: #fff;
    margin: 0;
}

.popup-checkbox {
    display: flex;
    align-items: center;
    gap: 5px;
}

.popup-checkbox label {
    color: #fff;
    font-size: 14px;
}

button {
    padding: 8px 12px;
    border: none;
    color: white;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
}
</style>
